module.exports = __webpack_public_path__ + "media/images/smiley-executive-board 2-9ff5f4c4d9bcb61180b6350f730bbbde.png";